import { render, staticRenderFns } from "./ProductItemthree.vue?vue&type=template&id=294f5330&scoped=true"
import script from "./ProductItemthree.vue?vue&type=script&lang=js"
export * from "./ProductItemthree.vue?vue&type=script&lang=js"
import style0 from "./ProductItemthree.vue?vue&type=style&index=0&id=294f5330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f5330",
  null
  
)

export default component.exports